import { render, staticRenderFns } from "./MarketingSubheader.vue?vue&type=template&id=4372aac2&scoped=true&lang=html&"
import script from "./MarketingSubheader.vue?vue&type=script&lang=js&"
export * from "./MarketingSubheader.vue?vue&type=script&lang=js&"
import style0 from "./MarketingSubheader.vue?vue&type=style&index=0&id=4372aac2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372aac2",
  null
  
)

export default component.exports